// Libraries
import { FilterFn } from '@tanstack/react-table';

/**
 * Applies a fuzzy filter to a row in a table.
 *
 * @param {unknown} row - The row to filter.
 * @param {string} columnId - The ID of the column to filter.
 * @param {string} value - The value to filter by.
 * @returns {boolean} - Indicates whether the item should be filtered in/out.
 */
export const caseInsensitiveFilter: FilterFn<unknown> = (row, columnId, value) => {
  const search = value.toString().toLowerCase();

  return Boolean(row.getValue<string | null>(columnId)?.toString().toLocaleLowerCase()?.includes(search));
};
